/**
 *
 * @param {string} url
 * @returns {{url: string, query: string, hash: string}} obj
 */
export var parseUrl = function (url) {
  if (url === void 0) {
    url = window.location.href;
  }
  var _url$split = url.split('?'),
    newUrl = _url$split[0],
    _url$split$ = _url$split[1],
    query = _url$split$ === void 0 ? '' : _url$split$;
  var hash = '';
  if (newUrl.includes('#')) {
    var _newUrl$split = newUrl.split('#');
    newUrl = _newUrl$split[0];
    hash = _newUrl$split[1];
  } else if (query.includes('#')) {
    var _query$split = query.split('#');
    query = _query$split[0];
    hash = _query$split[1];
  }
  return {
    url: newUrl,
    query: getQueryParams(query),
    hash: hash
  };
};

/**
 *
 * @param {string} str
 * @param {boolean} decode default true
 * @returns {object} query object
 */
export var getQueryParams = function (str, decode) {
  if (str === void 0) {
    str = window.location.search;
  }
  if (decode === void 0) {
    decode = true;
  }
  var queryStr = str;
  if (str.includes('?')) {
    var _str$split = str.split('?');
    var _str$split$ = _str$split[1];
    queryStr = _str$split$ === void 0 ? '' : _str$split$;
  }
  if (queryStr.includes('#')) {
    var _queryStr$split = queryStr.split('#');
    var _queryStr$split$ = _queryStr$split[0];
    queryStr = _queryStr$split$ === void 0 ? '' : _queryStr$split$;
  }
  var queryArr = queryStr.split('&');
  var query = {};
  while (queryArr.length) {
    var item = queryArr.shift();
    var _item$split = item.split('='),
      _item$split$ = _item$split[0],
      k = _item$split$ === void 0 ? '' : _item$split$,
      _item$split$2 = _item$split[1],
      v = _item$split$2 === void 0 ? '' : _item$split$2;
    if (k) {
      try {
        query[k] = decode ? decodeURIComponent(v) : v;
      } catch (e) {
        query[k] = v;
      }
    }
  }
  return query;
};

/**
 *
 * @param {object} obj
 * @param {boolean} encode default true
 * @returns {string} query
 */
export var stringify = function (obj, encode) {
  if (obj === void 0) {
    obj = {};
  }
  if (encode === void 0) {
    encode = true;
  }
  var strArr = [];
  Object.keys(obj).forEach(function (k) {
    var v = obj[k] || '';
    strArr.push(k + "=" + (encode ? encodeURIComponent(v) : v));
  });
  return strArr.join('&');
};

/**
 *
 * @param {string} url
 * @param {object} obj
 * @returns {string} newUrl
 */
export var stringifyUrl = function (url, obj) {
  if (obj === void 0) {
    obj = {};
  }
  var _parseUrl = parseUrl(url),
    newUrl = _parseUrl.url,
    query = _parseUrl.query,
    hash = _parseUrl.hash;
  var urlStr = newUrl;
  var search = stringify(Object.assign({}, query, obj));
  if (search) {
    urlStr = newUrl + "?" + search;
  }
  if (hash) {
    urlStr = urlStr + "#" + hash;
  }
  return urlStr;
};
export default {
  parseUrl: parseUrl,
  getQueryParams: getQueryParams,
  stringify: stringify,
  stringifyUrl: stringifyUrl
};